import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { CardContentContainer } from './card-content.styled';
import { CardExtras, CardHeaderContainer, CardTitle } from './card-header.styled';
const getOuterPadding = (padding, useRedesign) => {
    switch (padding) {
        case true:
            return ({ theme }) => css `
				padding: ${pxToRem(theme.spacing['200'])};

				${useRedesign &&
                css `
					padding: 0;
				`}

				@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
					padding: ${pxToRem(theme.spacing['300'])};
				}
			`;
        case 'horizontal':
            return ({ theme }) => css `
				padding: 0 ${pxToRem(theme.spacing['200'])};

				${useRedesign &&
                css `
					padding: 0;
				`}

				@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
					padding: 0 ${pxToRem(theme.spacing['300'])};
				}
			`;
        case 'vertical':
            return ({ theme }) => css `
				padding: ${pxToRem(theme.spacing['200'])} 0;

				${useRedesign &&
                css `
					padding: 0;
				`}

				@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
					padding: ${pxToRem(theme.spacing['300'])} 0;
				}
			`;
        default:
            return null;
    }
};
/**
 * Card container
 */
export const cardContainerStyles = ({ $inactive, $padding, $useRedesign, }) => css `
	position: relative;
	${getOuterPadding($padding, $useRedesign)}

	${$inactive &&
    css `
		 {
			opacity: 0.3;
			pointer-events: none !important;
		}
	`}
`;
export const CardContainer = styled.div `
	${cardContainerStyles}
`;
/**
 * Card main
 */
export const cardMainStyles = ({ theme, $collapsable, $collapsed, $useRedesign, }) => css `
	position: relative;
	display: block;
	padding: ${pxToRem(theme.spacing['200'])};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${theme.colors.extralight.bgCards};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		padding: ${pxToRem(theme.spacing['300'])};
	}

	${$useRedesign &&
    css `
		padding: 0;
		border-radius: 0;
		background-color: initial;
		border-bottom: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.extralight.bgCards};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			border-radius: ${pxToRem(theme.borderRadius.m)};
			border: ${pxToRem(theme.borderWidth['2'])} solid ${theme.colors.extralight.bgCards};
		}

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
			padding: 0;
		}
	`}

	${$collapsable &&
    $collapsed &&
    css `
		:hover ${CardHeaderContainer} ${CardTitle} {
			color: ${theme.colors.highlight.textHover};
		}

		:active ${CardHeaderContainer} ${CardTitle} {
			color: ${theme.colors.action.textAction};
		}

		${CardContentContainer} {
			display: none;
		}

		${CardExtras} {
			@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
				display: none;
			}
		}

		${CardHeaderContainer} {
			@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
				margin-bottom: 0;
			}
		}

		${CardWrapper} {
			display: none;
		}
	`}
`;
export const CardMain = styled.div `
	${cardMainStyles}
`;
/**
 * Card wrapper
 */
export const cardWrapperStyles = ({ theme, $useRedesign, $useBackground, }) => css `
	display: block;

	${$useRedesign &&
    css `
		padding: ${pxToRem(theme.spacing['300'])};
		border-radius: 0;

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			border-radius: 0 0 ${pxToRem(theme.borderRadius.m)} ${pxToRem(theme.borderRadius.m)};
		}

		${$useBackground &&
        css `
			background-color: ${theme.colors.blanc.bgCards};
		`}

		${!$useBackground &&
        css `
			background-color: ${theme.colors.extralight.bgCards};
		`}
	`}
`;
export const CardWrapper = styled.div `
	${cardWrapperStyles}
`;
//# sourceMappingURL=card.styled.js.map